import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8z7zv9rr: FaireBrandEntity = {
  token: "b_8z7zv9rr",
  type: "brand",
  name: "Wind River",
  avatarUrl:
    "https://cdn.faire.com/fastly/b820b28e9ec773616a459e7efe634b8bf965bfe27bf9d899440ef4fe7fe9a19e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0a6ddaedd8d54c8431d92e0b195aa287191d083b5a6eee53342e4924aaaa4a7f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b820b28e9ec773616a459e7efe634b8bf965bfe27bf9d899440ef4fe7fe9a19e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0a6ddaedd8d54c8431d92e0b195aa287191d083b5a6eee53342e4924aaaa4a7f.jpeg",
  location: "Manassas Park, VA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 78,
  isTopShop: true,
  isInsider: true,
  description:
    "At Wind River, we strive to leave the world a little better than we found it—through our employee development programs, our community involvement, and the soothing notes of our signature products. We don’t simply make chimes. We shape environments—at our company, in our community, and beyond.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:27.985Z",
    importedBy: "entity-db-cli",
  },
};
